import React from 'react';
import { useState } from 'react';
import { CircularProgress, ListItemIcon, ListItemText } from '@mui/material';
import { useAppDispatch } from '../../app/hooks';
import Button from '@mui/material/Button';
import { StandardDialogActions } from '../Modals/StandardDialog';
import { Typography } from '@mui/material';
import { startMasquerade } from '../../app/store/masqueradeSlice';
import { fetchUserDataByToken } from '../../app/store/userSlice';
import { useNavigate } from 'react-router-dom';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import MenuItem from '@mui/material/MenuItem';
import StandardDialog from '../Modals/StandardDialog';

interface Props {
  userId: number;
  userDisplay: string;
}

export default function MasqueradeMenuItem({ userId, userDisplay }: Props) {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const nav = useNavigate();
  const initiateMasquerade = async () => {
    setIsFetching(true);
    dispatch(startMasquerade({ userId, userDisplay }));
    await dispatch(fetchUserDataByToken());
    nav('/profile', { replace: true });
    setIsFetching(false);
  };

  return (
    <div>
      <StandardDialog
        title={`Masquerade As ${userDisplay}`}
        handleClose={() => setOpen(false)}
        isOpen={open}
      >
        <Typography>When masquerading as a user all actions will be as though you are that user. Take caution.</Typography>
        <StandardDialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpen(false)}
          >Cancel</Button>
          <Button
            variant="outlined"
            onClick={() => initiateMasquerade()}
            disabled={isFetching}
            startIcon={isFetching ? <CircularProgress size={20} /> : <TheaterComedyIcon />}
          >Masquerade</Button>
        </StandardDialogActions>
      </StandardDialog>
      <MenuItem onClick={() => setOpen(true)}>
        <ListItemIcon><TheaterComedyIcon /></ListItemIcon>
        <ListItemText>Masquerade As</ListItemText>
      </MenuItem>
    </div>
  );
}
